import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initialLoading } from '@actions/app';
import Loading from "../../components/feedback/Loading/Loading";

const AppDataContainer = ({ children }) => {
  const dispatch = useDispatch();
  const cities = useSelector((state) => state.app.cities.data);

  useEffect(() => {
    dispatch(initialLoading());
  }, [dispatch]);

  if (!cities?.length) {
    return <Loading />;
  }

  return children;
};

export default AppDataContainer;
